const API_URL = process.env.REACT_APP_CONN;

export async function createConnection(
  authFetch,
  { label, source_node, target_node },
) {
  const response = await authFetch(`${API_URL}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label, source_node, target_node }),
  });

  return response.json();
}

export async function updateConnection(authFetch, { id, label }) {
  const response = await authFetch(`${API_URL}${id}/`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label }),
  });

  return response.json();
}

export async function deleteConnection(authFetch, { id }) {
  const response = await authFetch(`${API_URL}${id}/`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text);
  }

  return true;
}
